import { useEffect, useState } from 'react';

import { fmt, texts } from '@/lib/texts';

/** С какого остатка показываем секунды и красим бронь в красные чернила (marketing.md, вопрос 12). */
export const HOLD_HOT_MS = 2 * 60_000;

export interface HoldState {
  /** Сколько миллисекунд осталось (не меньше 0) */
  leftMs: number;
  /** Последние две минуты: «м:сс» и красные чернила */
  hot: boolean;
  /** Бронь истекла */
  over: boolean;
  /** Отсчёт для показа: «12 мин» до последних двух минут, дальше «1:37» */
  label: string;
}

/** Остаток брони: минуты, а в последние две минуты — «м:сс». */
export function holdLabel(leftMs: number): string {
  const ms = Math.max(0, leftMs);
  if (ms > HOLD_HOT_MS) return fmt(texts.countdown.minutes, { m: Math.ceil(ms / 60_000) });
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Отсчёт брони заявки. Обновляется раз в 15 секунд, а в последние две минуты — каждую секунду:
 * на слабом Android таймер на весь экран не перерисовывается впустую.
 */
export function useHold(until: string | null): HoldState | null {
  const target = until ? Date.parse(until) : NaN;
  const [now, setNow] = useState(() => Date.now());
  const left = Number.isFinite(target) ? target - now : NaN;
  const fast = Number.isFinite(left) && left <= HOLD_HOT_MS + 15_000 && left > -1000;

  useEffect(() => {
    if (!Number.isFinite(target)) return;
    const id = window.setInterval(() => setNow(Date.now()), fast ? 1000 : 15_000);
    return () => window.clearInterval(id);
  }, [target, fast]);

  if (!Number.isFinite(left)) return null;
  return {
    leftMs: Math.max(0, left),
    hot: left <= HOLD_HOT_MS,
    over: left <= 0,
    label: holdLabel(left),
  };
}
